import React from "react";
import { useSelector } from "react-redux";
import { Redirect } from "react-router-dom";
import { ROLES } from "../../../../../constants/rolesConstants";

const TasksRedirect = () => {
  const { user } = useSelector((state) => ({
    user: state.currentUser,
  }));

  if (!user) {
    return null;
  }

  const userRoles = user.roles || [];
  
  // PKO_OFFICE_US users go to PKO (US) tab
  if (userRoles.includes(ROLES.PKO_OFFICE_US)) {
    return <Redirect to="/tasks/pko-us" />;
  }

  // Default to PKO for PKO_OFFICE and ADMIN users
  return <Redirect to="/tasks/pko" />;
};

export default TasksRedirect;

